import { render, staticRenderFns } from "./DrawerProfile.vue?vue&type=template&id=68df38b6&scoped=true&"
import script from "./DrawerProfile.vue?vue&type=script&lang=js&"
export * from "./DrawerProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68df38b6",
  null
  
)

export default component.exports